import styles from "./Dropdown.module.css";

const DropdownLabel: React.FC<{ label: string }> = ({ label }) => {
    return (
        <label className={styles.dropdown_label}>{label}</label>
    );
}

export default DropdownLabel;